<script>
  export let title = "default title";
  export let totalExpenses = 0;
</script>

<section class="main-title">
  <h2>{title} : $ {totalExpenses}</h2>
</section>
